import { jsxs, jsx } from "react/jsx-runtime";
const IconSentimentNegativeSvg = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    fill: "currentColor",
    width: 16,
    height: 16,
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M12 23C5.935 23 1 18.065 1 12S5.935 1 12 1s11 4.935 11 11-4.935 11-11 11Zm0-20c-4.963 0-9 4.037-9 9s4.037 9 9 9 9-4.037 9-9-4.037-9-9-9Z" }),
      /* @__PURE__ */ jsx("circle", { cx: 9.5, cy: 9.5, r: 1.5 }),
      /* @__PURE__ */ jsx("circle", { cx: 14.5, cy: 9.5, r: 1.5 }),
      /* @__PURE__ */ jsx("path", { d: "M16.001 18a.999.999 0 0 1-.8-.4C14.436 16.584 13.27 16 12 16s-2.437.583-3.2 1.6a1.001 1.001 0 0 1-1.6-1.2C8.346 14.874 10.095 14 12 14s3.654.875 4.8 2.4A1.001 1.001 0 0 1 16 18Z" })
    ]
  }
);
export {
  IconSentimentNegativeSvg
};
